/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElementsUserProfileUpdate
 */
export interface ElementsUserProfileUpdate {
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfileUpdate
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfileUpdate
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfileUpdate
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfileUpdate
     */
    language?: ElementsUserProfileUpdateLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserProfileUpdate
     */
    fmBookmarks?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserProfileUpdateLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserProfileUpdateFromJSON(json: any): ElementsUserProfileUpdate {
    return ElementsUserProfileUpdateFromJSONTyped(json, false);
}

export function ElementsUserProfileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserProfileUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
    };
}

export function ElementsUserProfileUpdateToJSON(value?: ElementsUserProfileUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'full_name': value.fullName,
        'language': value.language,
        'fm_bookmarks': value.fmBookmarks,
    };
}


